import React, { useState } from "react";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { buildApiUrl } from "../config/api";
import "./AdminLogin.css";

function AdminLogin() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const redirectPath = searchParams.get("redirect") || "/admin";

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [loggedIn, setLoggedIn] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    setLoading(true);
    setError("");

    try {
      const response = await fetch(buildApiUrl("/admin/auth/login"), {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          email,
          password,
        }),
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(data.message || "Admin login failed.");
      }

      setLoggedIn(true);
      navigate(redirectPath, { replace: true });
    } catch (err) {
      setError(err.message || "Admin login failed.");
    } finally {
      setLoading(false);
    }
  };

  if (loggedIn) {
    return <Navigate to={redirectPath} replace />;
  }

  return (
    <main className="mc-admin-login-page">
      <section className="mc-admin-login-card">
        <div className="mc-admin-login-brand">
          <h1>MayaChitro</h1>
          <p>Admin Panel</p>
        </div>

        <div className="mc-admin-login-copy">
          <span>Secure Access</span>
          <h2>Login to manage your marketplace.</h2>
          <p>
            Access products, orders, newsletter subscribers, visitor analytics,
            and private admin controls.
          </p>
        </div>

        <form className="mc-admin-login-form" onSubmit={handleSubmit}>
          <label>
            Admin Email
            <input
              type="email"
              placeholder="admin@example.com"
              value={email}
              autoComplete="email"
              onChange={(event) => setEmail(event.target.value)}
              required
            />
          </label>

          <label>
            Password
            <input
              type="password"
              placeholder="Enter password"
              value={password}
              autoComplete="current-password"
              onChange={(event) => setPassword(event.target.value)}
              required
            />
          </label>

          {error && <div className="mc-admin-login-error">{error}</div>}

          <button type="submit" disabled={loading}>
            {loading ? "Checking..." : "Login to Dashboard"}
          </button>
        </form>
      </section>
    </main>
  );
}

export default AdminLogin;
